module.exports = __webpack_public_path__ + "img/D_Health.d20a2754.png";